import React from "react";
import ReactApexChart from "react-apexcharts";

const TopSellsMonthsChart = ({ series = [], height = 400 }) => {
  const categories = series.map((item) => item.name);
  const values = series.map((item) => item.data[0]);

  const processedSeries = [
    {
      name: "Total Sales",
      data: values,
    },
  ];

  const monthColors = [
    "#E53935",
    "#1E90FF",
    "#43A047",
    "#8E24AA",
    "#00ACC1",
    "#FFA000",
    "#009688",
    "#795548",
    "#607D8B",
    "#C2185B",
    "#2B1FA2",
    "#FBC02D",
  ];

  const options = {
    chart: {
      type: "bar",
      height,
      toolbar: { show: false },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        columnWidth: "50%",
        borderRadius: 6,
        distributed: true,
      },
    },
    dataLabels: {
      enabled: false,
    },
    xaxis: {
      categories,
    },
    yaxis: {
      labels: {
        formatter: (val) => val.toLocaleString(),
      },
    },
    tooltip: {
      y: {
        formatter: (val) => `\$${val.toLocaleString()}`,
      },
    },
    colors: monthColors,
    legend: {
      show: false,
    },
  };

  return (
    <div className="p-6 bg-white rounded-2xl shadow-md">
      <h2 className="mb-2 card-title">Top Selling Months</h2>
      <ReactApexChart
        options={options}
        series={processedSeries}
        type="bar"
        height={height}
      />
    </div>
  );
};

export default TopSellsMonthsChart;
